import { PasswordButton, ProfileForm } from "@/components/auth/account-settings";
import { BillingSection } from "@/components/billing/billing-section";
import { ConsentSettingsLink } from "@/components/consent/consent-settings-link";
import { LocaleSelect } from "@/components/locale-select";
import { EmailNotifications } from "@/components/settings/email-notifications";
import { useT } from "@shared/client/locale";
import { useSession } from "@shared/client/session";
import { usePageTitle } from "@shared/client/view";

/** Une section : son titre à gauche, ses réglages à droite. */
function Section({ id, title, children }: { id?: string; title: string; children: React.ReactNode }) {
  return (
    <section className="grid scroll-mt-20 gap-5 border-t py-8 md:grid-cols-[200px_1fr] md:gap-10" id={id}>
      <h2 className="m-0 text-[15px] font-semibold">{title}</h2>
      <div className="grid min-w-0 gap-5">{children}</div>
    </section>
  );
}

export default function SettingsPage() {
  const t = useT();
  usePageTitle(t.settings.page.documentTitle);
  const user = useSession()?.user;
  const page = t.settings.page;

  return (
    <div className="max-w-[920px]">
      <h1 className="mt-0 mb-7 font-serif text-[clamp(28px,3vw,34px)] leading-[1.1] font-normal tracking-[-0.02em]">
        {page.title}
      </h1>
      <Section id="abonnement" title={page.sections.subscription}>
        <BillingSection />
      </Section>
      <Section title={page.sections.profile}>
        {user && <ProfileForm email={user.email} metadata={user.user_metadata ?? {}} />}
      </Section>
      <Section id="langue" title={t.common.language.label}>
        <div className="grid gap-2">
          <LocaleSelect id="account-locale" />
          <p className="m-0 max-w-[60ch] text-[12.5px] leading-[1.5] text-muted-foreground">{t.common.language.description}</p>
        </div>
      </Section>
      <Section id="notifications" title={page.sections.notifications}>
        <EmailNotifications />
      </Section>
      <Section title={page.sections.security}>
        <div>
          <PasswordButton />
        </div>
      </Section>
      <div className="flex flex-wrap items-center justify-between gap-3 border-t pt-5 text-[12px] text-muted-foreground">
        <span>{page.vatNote}</span>
        <ConsentSettingsLink className="cursor-pointer underline underline-offset-2 hover:text-foreground" />
      </div>
    </div>
  );
}
